import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

import { Role } from '@/types';
    import { usePermissions } from '@/composables/usePermissions';
    import DataTableActions from '@/components/datatable/DataTableActions.vue';
    import Delete from '@/components/Delete.vue';
    import EditRoles from './EditRoles.vue';
    import Permission from '@/enums/Permission';
    import QueryKey from '@/enums/QueryKey';

    interface Props {
        role: Role;
    }

    
export default /*@__PURE__*/_defineComponent({
  __name: 'RolesTableActions',
  props: {
    role: {}
  },
  setup(__props: any) {

    

    const { hasPermission } = usePermissions();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DataTableActions, { data: _ctx.role }, {
    default: _withCtx(() => [
      (_unref(hasPermission)(_unref(Permission).ROLES_UPDATE))
        ? (_openBlock(), _createBlock(EditRoles, {
            key: 0,
            role: _ctx.role
          }, null, 8, ["role"]))
        : _createCommentVNode("", true),
      (_unref(hasPermission)(_unref(Permission).ROLES_DELETE))
        ? (_openBlock(), _createBlock(Delete, {
            key: 1,
            route: _ctx.route('v2.roles.destroy', { id: _ctx.role.id }),
            "query-key": [_unref(QueryKey).ROLES],
            header: "roles.delete.title",
            description: "roles.delete.content"
          }, null, 8, ["route", "query-key"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["data"]))
}
}

})